import { render, staticRenderFns } from "./Flatpage.vue?vue&type=template&id=76029d17"
import script from "./Flatpage.vue?vue&type=script&lang=js"
export * from "./Flatpage.vue?vue&type=script&lang=js"
import style0 from "./Flatpage.vue?vue&type=style&index=0&id=76029d17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports